export const breaks = {
	xs: '320px',
	sm: '480px',
	ms: '540px',
	md: '760px',
	lg: '960px',
	xlg: '1080px',
	xl: '1200px',
	xxl: '1360px',
	xxxl: '2160px'
}

export const gutters = {
    xxs: '2px',
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xlg: '36px',
    xl: '48px',
    xxl: '72px',
    xxxl: '120px'
}

export const fontSize = {
    xs: '11px',
    sm: '12px',
    xsm: '14px',
    md: '16px',
    xmd: '20px',
    lg: '24px',
    xl: '30px',
    xxl: '48px'
}

export const headingSize = {
    sm: '64px',
	md: '72px',
    lg: '92px',
	xl: '108px',
}

export const grey = {
	0: '#ffffff',
	50: '#fcfbfa',
	100: '#f9f8f6',
	200: '#f3f1ee',
	300: '#e7e6e4',
	400: '#c4c3c0',
	500: '#9c9c9b',
	600: '#82817d',
	700: '#575553',
	900: '#2a2825',
	1000: '#000000'
}

export const bgColors = {
    grape: '#ffdfff',
    fog: '#dadee9',
    seafoam: '#aaffcf',
    starlight: '#dfefff',
    ice: '#bbe4ea',
    'ghost green': '#efefcf',
    chestnut: '#ddadaf',
    sand: '#ffefcf',
    banana: '#ffefbf',
    curd: '#fff9d0'
}